import { type Color } from '@mui/material'

export const red = {
  100: '#FBE6E7',
  200: '#F6D4CD',
  300: '#EEAA9B',
  400: '#E57F69',
  500: '#DD5537',
  600: '#D42A05',
  700: '#AA2204',
  800: '#7F1903',
  900: '#551102',
} satisfies Partial<Color>
